module.exports = __webpack_public_path__ + "static/media/vintage_action_house.a1c0ba69.png";